import React from 'react';
import { Home, Ruler } from 'lucide-react';

/**
 * Секция формы с параметрами комнаты
 */
const RoomParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Home className="w-5 h-5 mr-2 text-indigo-500" />
        Размеры комнаты
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Длина комнаты */}
        <div>
          <label htmlFor="roomLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-indigo-500" />
            Длина (м)
          </label>
          <input
            type="text"
            id="roomLength"
            name="roomLength"
            value={formData.roomLength}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.roomLength ? 'input-error' : ''}`}
            placeholder="Длина комнаты"
          />
          {errors.roomLength && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomLength}
            </p>
          )}
        </div>

        {/* Ширина комнаты */}
        <div>
          <label htmlFor="roomWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-indigo-500" />
            Ширина (м)
          </label>
          <input
            type="text"
            id="roomWidth"
            name="roomWidth"
            value={formData.roomWidth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.roomWidth ? 'input-error' : ''}`}
            placeholder="Ширина комнаты"
          />
          {errors.roomWidth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomWidth}
            </p>
          )}
        </div>

        {/* Высота комнаты */}
        <div>
          <label htmlFor="roomHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-indigo-500" />
            Высота (м)
          </label>
          <input
            type="text"
            id="roomHeight"
            name="roomHeight"
            value={formData.roomHeight}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.roomHeight ? 'input-error' : ''}`}
            placeholder="Высота комнаты"
          />
          {errors.roomHeight && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomHeight}
            </p>
          )}
        </div>
      </div>

      {/* Расчетные параметры (периметр и площадь) */}
      <div className="mt-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-md p-3 border border-indigo-100 dark:border-indigo-800 grid grid-cols-2 gap-4">
        <div>
          <span className="block text-xs text-indigo-700 dark:text-indigo-300">Периметр стен:</span>
          <span className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
            {formData.roomPerimeter} м
          </span>
        </div>
        <div>
          <span className="block text-xs text-indigo-700 dark:text-indigo-300">Площадь стен:</span>
          <span className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
            {formData.roomArea} м²
          </span>
        </div>
      </div>
    </div>
  );
};

export default RoomParametersSection;